import * as TabsPrimitive from "@radix-ui/react-tabs";
import React from "react";

import { cn } from "../cn";

export function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" className={className} {...props} />;
}

export function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn("tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1 tw-rounded-xl tw-border tw-border-solid tw-border-border tw-p-1 tw-font-sans", className)}
      {...props}
    />
  );
}

export function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "tw-inline-flex tw-min-h-8 tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg",
        "tw-cursor-pointer tw-appearance-none tw-border-0 tw-bg-transparent tw-px-2.5 tw-py-[5.5px]",
        "tw-text-sm tw-font-medium tw-leading-5 tw-text-foreground tw-transition-all",
        "tw-outline-none focus-visible:tw-border-ring focus-visible:tw-ring focus-visible:tw-ring-ring/50",
        "disabled:tw-pointer-events-none disabled:tw-opacity-50",
        "data-[state=active]:tw-bg-clay",
        "[&_svg:not([class*='size-'])]:tw-size-4 [&_svg]:tw-pointer-events-none [&_svg]:tw-shrink-0",
        className,
      )}
      {...props}
    />
  );
}

export function TabsCounter({ className, children, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      className={cn(
        "tw-inline-flex tw-min-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-px-2 tw-py-1 tw-text-xs tw-font-bold tw-leading-4 tw-text-primary-foreground",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn("tw-mt-4 tw-outline-none", className)} {...props} />;
}
